import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthActions } from 'src/app/state/store/auth/auth.actions';

@Component({
  selector: 'app-unauthorized',
  imports: [],
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.scss'
})
export class UnauthorizedComponent {
  constructor(private readonly location: Location, private readonly store: Store) {}

  goBack(): void {
    this.location.back();
  }
  logout(): void {
    // Implement logout logic here
    this.store.dispatch(AuthActions.logout({})); // Assuming you have a logout action defined
  }
}
